import React from 'react';

const ChevronLeftIcon = () => {
	return (
		<svg
			data-testid='chevron-left'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M12.1875 15L7.1875 10L12.1875 5L12.8124 5.62489L8.43728 10L12.8124 14.3751L12.1875 15Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default ChevronLeftIcon;
